module.exports = __webpack_public_path__ + "img/grey_045.74102982.png";